import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import Button from '@components/Button';
import Input from '@components/Input';
import Switch from '@components/Switch';

import style from './Email.scss';

const cn = bemCssModules(style, 'Email');

export type TEmail = {
  onSubmit(event: React.FormEvent<HTMLFormElement>): void;
  onChangeEmail(event: React.ChangeEvent<HTMLInputElement>): void;
  onChangeAgree(checked: boolean): void;
  email: string;
  error?: React.ReactNode;
  isAgree: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export const Email: CustomFC<TEmail> = props => {
  const {
    onSubmit,
    onChangeEmail,
    onChangeAgree,
    className,
    email,
    error,
    isLoading,
    isDisabled,
    isAgree,
  } = props;

  const { t } = useTranslation();

  const errorText =
    typeof error === 'string' && error?.includes('has already been taken') ? (
      <Trans i18nKey="email.already_taken">
        text
        <a href="mailto:support@mercuryo.io" className={cn('link', ['link'])}>
          support@mercuryo.io
        </a>
      </Trans>
    ) : (
      error
    );

  return (
    <form className={cn(null, [className])} onSubmit={onSubmit}>
      <Input
        className={cn('input')}
        value={email}
        name="email"
        type="email"
        error={errorText}
        isLoading={isLoading}
        onChange={onChangeEmail}
        placeholder="mercuryo@mercuryo.io"
        inputMode="email"
        autoComplete="off"
        autoFocus
      />
      <div className={cn('accept')}>
        <Switch value={isAgree} onChange={onChangeAgree}>
          {t('accept.newsletter')}
        </Switch>
      </div>

      <Button className={cn('button')} type="submit" disabled={isDisabled}>
        {t('public.get_the_code')}
      </Button>
    </form>
  );
};

export default Email;
